import { useParams, Link } from 'react-router-dom';
import PageSEO from '@/components/feature/PageSEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { getArticlesByCategory, getCategoryBySlug, articles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || '');
  const categoryArticles = getArticlesByCategory(slug || '');

  if (!category) {
    return (
      <div className="pt-20 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-7xl mx-auto">
          <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">分类不存在</h1>
          <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm cursor-pointer">
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 今日同人库`,
    description: category.description,
    url: `https://todaydoujin.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '今日同人库',
      url: 'https://todaydoujin.com/',
    },
  };

  const otherCategories = [
    { slug: 'doujin-novel', name: '同人小说' },
    { slug: 'doujin-art', name: '同人画作' },
    { slug: 'doujin-music', name: '同人音乐' },
    { slug: 'doujin-goods', name: '周边资讯' },
    { slug: 'cp-recommend', name: 'CP推荐' },
  ].filter((c) => c.slug !== slug);

  return (
    <>
      <PageSEO
        title={`${category.name} - 同人作品精选`}
        description={category.description}
        keywords={`${category.name},今日同人库,同人内容聚合,每日同人推荐`}
        canonicalUrl={`/category/${slug}`}
        jsonLd={jsonLd}
      />

      <div className="pt-20">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: category.name },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-4">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600">
                <i className={`${category.icon} text-2xl`}></i>
              </div>
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
                {category.name}
              </h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
                {category.description}
              </p>
            </div>

            <div className="flex items-center justify-center gap-2 flex-wrap mb-8">
              {otherCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-2 rounded-full bg-background-100 text-foreground-600 text-sm font-medium hover:bg-secondary-100 hover:text-secondary-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop>
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
}